<template>
    <div class="vue timparty-user-widget user-widget d-flex d-align-items-center">

      <div class="badges-container d-flex align-items-center" v-if="userBadgesCount !== null">
        <div v-if="!is_ended">
          <img :src="modulePath('/js/src/assets/images/icon-teal-badge.png')" class="icon-badge"><strong class="text-accent">{{ userBadgesCount }}</strong>&nbsp;<span class="d-none d-sm-inline-block">Badge</span>
        </div>

      </div>

      <div class="avatar-container text-center d-none d-sm-inline-block">
        <a @click='aaEvent("click", { form: { click: "Scopri vantaggi" } })' href="/profilo"><img :src="modulePath('/js/src/assets/images/icon-white-avatar.png')" class="icon-avatar"></a>
        <div v-if="user" class="d-none d-md-block user-cluster">{{ user.cluster_name }}</div>
      </div>

      <div class="logout-container text-center d-none d-sm-inline-block" v-if="!hide_logout">
        <a @click='aaEvent("click", { form: { click: "Esci" } })' href="#" @click.prevent="logout"><img :src="modulePath('/js/src/assets/images/icon-white-logout.png')" class="icon-logout d-none d-sm-inline-block"></a>
      </div>


      <user-popup></user-popup>
    </div>
</template>

<script>

    /* eslint-disable */

    import moment                   from "moment/moment";
    import TimPartyMixin            from '../mixins/TimPartyMixin';
    import { mapState, mapGetters } from 'vuex'

    import sha512 from 'js-sha512';


    import IconBadge from '../assets/images/icon-badge.svg';
    import UserPopup from './UserPopup';

    export default {
      name: 'UserWidget',
      mixins: [ TimPartyMixin ],
      components: { IconBadge, UserPopup },
      props: {
        accessToken: String,
        apiUrl: String,
        endDatePartyColl: {
          type: String,
          default: '20230108235959'
        }
      },

      data: function(){
        return {
          refreshing_token: false,
          is_ended: false,
        };
      },

      mounted: function(){
        var self = this;

        window.addEventListener('timparty_update_badges', function(){
          console.log('EVENT timparty_update_badges received');
          self.getUserBadges();
        });

        window.addEventListener('timparty_refresh_token', function(){
          console.log('EVENT timparty_refresh_token received');
          self.refreshAccessToken();
        });

        window.addEventListener('timparty_refresh_mgm_initiative', function(){
          console.log('EVENT timparty_refresh_mgm_initiative received');
          self.getMGMInitiative();
        });

        window.addEventListener('timparty_refresh_notifications', function(){
          console.log('EVENT timparty_refresh_notifications received');
          self.getNotifications();
        });

        this.setApiUrl(this.apiUrl);


        this.getAccessToken();
        this.getUser();
        this.isEndedPartyColl();

        // Impostiamo un ritardo per permettere al backend di calcolare le offerte
        setTimeout(this.getNotifications, 1000);
      },

      methods: {

        getUser: function() {
            var self = this;

            var payload = {
                action: 'getUser',
            };

            self.loading = true;
            this.callApi( payload, function( response){

                if( response.data != undefined){
                  self.$store.commit('updateUser', response.data);
                }

                // dev
                const urlParams = new URLSearchParams(window.location.search);
                const is_dev = urlParams.get('timparty_dev');
                const is_dev_password = urlParams.get('timparty_dev_password');

                if(is_dev === '1' && is_dev_password){

                  var hashed = sha512(is_dev_password);

                  if(hashed === '334d30f5b9e6ee044aab81629a31c110cb06ca2b6a9204aec3266e5c13ac104b4ab0073cfec00084524418379ea149a33d45c8158076ecbbc7ba241f0d6b0a80'){
                    console.log('Forcing DEV Environment')
                    self.$store.commit('setEnvironment', 'dev');
                  }


                }

            });

            // this.getMGMInitiative();
        },

        getMGMInitiative: function () {
          let self = this;
          let payload = {
            action: 'getMGMInitiative',
          };
          self.loading = true;

          this.callApi( payload, function(response){
            if(response != null) {
              self.$store.commit('setMGMInitiative', response);
            }
          });
        },

        getNotifications: function () {
          let self = this;
          let payload = {
            action: 'getNotifications',
          };
          self.loading = true;

          this.callApi( payload, function(response){
            if(response != null) {
              self.$store.commit('setNotifications', response);
            }
          });
        },

        logout: function() {
          var url = this.apiUrl + '?action=logout';

          window.location.href = url;

        },


        getAccessToken: function() {
            var self = this;

            var payload = {
                action: 'getAccessToken',
            };

            self.loading = true;
            this.callApi( payload, function( response){

                if( response.data != undefined && response.data.access_token != undefined)
                  self.$store.commit('setAccessToken', response.data.access_token);
                else{
                  // self.logout();
                }

            });
        },

        refreshAccessToken: function() {

            if( this.refreshing_token )
              return;

            this.refreshing_token = true;

            var self = this;

            var payload = {
                action: 'refreshAccessToken',
            };

            self.loading = true;
            this.callApi( payload, function( response){



                if( response.data != undefined && response.data.access_token != undefined && response.data.access_token){
                  console.log('refreshAccessToken ', response.data.access_token);
                  self.$store.commit('setAccessToken', response.data.access_token);


                  if( self.environment == 'prod' )
                    window.location.reload();
                }

            });
        },

        getUserBadges: function(){
          // loading user badges

          var self = this;

          var payload = {
            action: 'getBadges',
            access_token: this.accessToken,
          };

          self.loading = true;
          this.callApi( payload, function( response){
            self.loading = false;

            if( response.data != undefined && response.data.badgesAndCampaignList != undefined ) {
                self.$store.commit('setUserBadges', response.data.badgesAndCampaignList);
            }


          } );
        },
        isEndedPartyColl: function () {
          let end_date = moment(this.endDatePartyColl, 'YYYYMMDDHHmmss');
          const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
          });

          let today = params.today ? moment(params.today, 'YYYYMMDDHHmmss') : moment();
          this.is_ended = today.isAfter(end_date);
        },
      },

      computed: {
         ...mapGetters([
            'userBadgesCount',
          ]),

          hide_logout: function(){

            return  ( this.user ? this.user.is_mobile_app : true);

          }

      },
      watch: {
        access_token: function(){
          this.getUserBadges();
        }
      }

    }
  </script>


